export default __webpack_public_path__ + "static/media/buttonSFX.872b6c3b.mp3";